import React from 'react'
import { connect } from 'react-redux'
import { removeLayer, addLayer, filterLayer } from '../actions'
import ToggleLegend from './ToggleLegend'
import $ from "jquery";

let ToggleLayer = ({ section, item, title, group, exclusive, id, children, dispatch }) => {
  let layerId = id


  return (
    <li><a className="layer" id={ id } data-exclusive={ exclusive } data-group={ group } href="/layers/layer" onClick={e => {
      e.preventDefault()

      $('body').addClass(section + '-layer-on')

      if (item.children) {
        var position = $(e.target).position()
        $('.tertiary-menu').hide()
        $(e.target).parent('li').find('.tertiary-menu')
          .css('left', position.left)
          .show()
      }

      if (item.filter) {
        $('.secondary:visible li a.layer.layer-on').removeClass('layer-on')
        $(e.target).addClass('layer-on')
        dispatch(filterLayer(item.filter))
      }

      if (item.id) {
        if ($(e.target).hasClass('layer-on')) {
          $(e.target).removeClass('layer-on')
            if (item.exclusive === true) {
              var layers,
                  labels
              if (children) {
                layers = $('.tertiary-menu [data-group="' + item.group + '"]')
                labels = $('.tertiary-menu [data-labels]')
              } else {
                layers = $('[data-group="' + item.group + '"]')
              }
              $.each(layers, function(i, l) {
                var lid = $(l).attr('id');
                $(l).removeClass('layer-on')
                dispatch(removeLayer(lid))
              })
              $.each(labels, function(i, l) {
                var lid = $(l).data('labels');
                $(l).removeClass('layer-on')
                dispatch(removeLayer(lid))
              })
              dispatch(removeLayer(layerId))
              $(e.target).parent('li').find('.tertiary-menu').hide()
            } else {
              dispatch(removeLayer(layerId))
              $(e.target).parent('li').find('.tertiary-menu .tertiary li:first-child a')
               .removeClass('layer-on')
            }
        } else {
          if (item.exclusive === true) {
            $('.secondary:visible li a.layer.layer-on').removeClass('layer-on')
            if (children) {
              layers = $('.tertiary-menu [data-group="' + item.group + '"]')
              labels = $('.tertiary-menu [data-labels]')
            } else {
              layers = $('[data-group="' + item.group + '"]')
            }
            $.each(layers, function(i, l) {
              var lid = $(l).attr('id');
              $(l).removeClass('layer-on')
              dispatch(removeLayer(lid))
            })
            $.each(labels, function(i, l) {
              var lid = $(l).data('labels');
              $(l).removeClass('layer-on')
              dispatch(removeLayer(lid))
            })
          }
          $(e.target).addClass('layer-on')
          dispatch(addLayer(layerId))
          var firstMenuItem = $(e.target).parent('li').find('.tertiary-menu .tertiary li:first-child a')
          if (children) {
            firstMenuItem.addClass('layer-on')
            labels = firstMenuItem.data('labels')
            dispatch(addLayer(labels))
          }
        }
      }

      var layerOn = $('.secondary:visible').find('.layer-on')
      //console.log(layerOn)
      if (layerOn.length === 0) {
        $('body').removeClass(section + '-layer-on')
        $('.tertiary-menu').hide()
      }

     }}
    >{ title }</a>
     <ToggleLegend layerId={ layerId } children={ children } />
    </li>
  )
}
ToggleLayer = connect()(ToggleLayer)

export default ToggleLayer



// WEBPACK FOOTER //
// ./src/containers/ToggleLayer.js